import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import { GlobalFooter } from "@/patterns/global-footer/src";

import { JPDBanner } from "../../banner/banner";

import JiraProductDiscoveryNavV2 from "./sections/product-nav";
import { AtlassianIntelligence } from "./sections/v2/ai";
import Community from "./sections/v2/community";
import CtaSection from "./sections/v2/cta";
import Customers from "./sections/v2/customers";
import Demo from "./sections/v2/demo";
import Hero from "./sections/v2/hero";
import { HowItWorks } from "./sections/v2/how-it-works";
import SideBySide from "./sections/v2/side-by-side";
import HeroVideo from "./sections/v2/video";
import Workflow from "./sections/v2/workflow";

export const JiraProductDiscoveryTemplate = () => {
    return (
        <>
            <JiraProductDiscoveryNavV2 />
            <TypographyStyles>
                <main id="content">
                    <JPDBanner />
                    <Hero />
                    <HeroVideo />
                    <Customers />
                    <Demo />
                    <SideBySide />
                    <AtlassianIntelligence />
                    <HowItWorks />
                    <Workflow />
                    <Community />
                    <CtaSection />
                </main>
            </TypographyStyles>
            <GlobalFooter />
        </>
    );
};
